import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-colour-picker',
  templateUrl: './colour-picker.component.html',
  styleUrls: ['./colour-picker.component.scss'],
})
export class ColourPickerComponent {
  @Input() control!: FormControl;
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  constructor() {}
}
